import React from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import moment, { Moment } from 'moment';
import { getTranslationKey } from '../../../modules/utils/helpers';

interface UseDesktopModalProps {
  isUseDesktopModalIsOpen: boolean;
  userCreatedAt: string | Moment;
  setUseDesktopModalVisibility: (isOpen: boolean) => void;
}

const UseDesktopModal: React.FC<UseDesktopModalProps> = ({
  isUseDesktopModalIsOpen,
  setUseDesktopModalVisibility,
  userCreatedAt
}) =>
  isUseDesktopModalIsOpen ? (
    <Modal
      centered
      isOpen={isUseDesktopModalIsOpen}
      toggle={() => setUseDesktopModalVisibility(!isUseDesktopModalIsOpen)}
      wrapClassName="modal-dark"
      size="md"
    >
      <ModalHeader toggle={() => setUseDesktopModalVisibility(!isUseDesktopModalIsOpen)}>
        {getTranslationKey('useDesktopModal.title')}
      </ModalHeader>
      <ModalBody>
        <p>{getTranslationKey('useDesktopModal.text')}</p>
        {moment(userCreatedAt).isAfter(moment().subtract(7, 'days')) && (
          <div className="m-t-3">
            <strong>{getTranslationKey('useDesktopModal.forNewLeads')}</strong>
            <p>{getTranslationKey('useDesktopModal.confirmEmailHint')}</p>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => setUseDesktopModalVisibility(!isUseDesktopModalIsOpen)}
          className="w-100-p"
          color="success"
        >
          {getTranslationKey('useDesktopModal.confirmed')}
        </Button>
      </ModalFooter>
    </Modal>
  ) : null;

interface Auth {
  created_at?: string;
  [key: string]: any;
}

interface RootState {
  message: {
    isUseDesktopModalIsOpen: boolean;
  };
  auth: Auth;
}

function mapStateToProps({ message: { isUseDesktopModalIsOpen }, auth }: RootState) {
  return {
    isUseDesktopModalIsOpen,
    userCreatedAt: auth.created_at || moment()
  };
}

export default connect(mapStateToProps, actions)(UseDesktopModal);
